// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* 見出しを進捗バー寄りに置く（選択式4ステップの従来位置）。\n   各ステップは見出しの上に72pxの余白を持つため、32px詰めて40pxにする */\n.SignupPage-module__steps___nc-aV {\n  margin-top: -32px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"steps": "SignupPage-module__steps___nc-aV"
};
export default ___CSS_LOADER_EXPORT___;
